import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  contentContainer: {
    paddingBottom: theme.spacing[5],
    gap: theme.spacing[4],
  },
});
